import React from "react";
import { height, width } from "components/CustomComponents/Card/CardStyles";
import DynamicCard from "components/CustomComponents/DynamicCard";
import { appTheme } from "helpers/utils/Utils";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { SHOW_SECURED_CREDIT_POPOVER } from "Redux/reducers";


const SecuredCreditCardPromotion = (Radius) => {
    const { t } = useTranslation();
    const kudzuPlusTrue = useSelector((state) => state.kudzuPlusTrue);
    const dispatch = useDispatch();
    const appThemeData = appTheme(kudzuPlusTrue);

    const showSecuredCreditPopover = () => {
        dispatch({ type: SHOW_SECURED_CREDIT_POPOVER });
    }
    return (

        <DynamicCard
            header={true}
            footer={true}
            isHome={true}
            cardHeight={height.perks_profile}
            cardWidth={width.homeCard}
            HeaderRadius={Radius}
            Radiusnone={true}
            CardRadius={Radius}
            IsSecuredCardPromotion={true}
        >
            <div className="flex flex-col md:flex-row p-6 sm:p-10 lg:p-14 gap-8 md:gap-10 lg:gap-16">

                <div className="flex-1 flex flex-col items-center md:items-start">
                    <h1 className=" max-w-[290px] font-serif-pro font-normal leading-tight text-center md:text-left">
                        <span className="inline md:inline text-[#A3CEBB] text-[24px] sm:text-[28px] lg:text-[32px]">
                            {t("BUILD_YOUR_CREDIT")}
                        </span>
                        <span className="pl-2 inline md:inline text-[var(--secured-card-text)] text-[24px] sm:text-[28px] lg:text-[32px]">
                            {t("WITH_SECURED_CARD")}
                        </span>
                    </h1>

                    <div className="mt-5 sm:mt-6 md:mt-8 flex justify-center md:block md:justify-start w-full">
                        <img
                            src={appThemeData.secured_card_front}
                            alt=""
                            className="w-[210px] sm:w-[167px] md:w-[240px] lg:w-[260px] h-auto rounded-md"
                        />
                    </div>
                </div>

                <div className="flex-1 flex flex-col items-center md:items-start gap-1">

                    <span className="hidden md:block
                        font-hanken-grotesk font-bold text-[18px]/[28px] tracking-[0em]
                        text-[#FEFAEE] text-left md:whitespace-nowrap md:max-w-none">
                        {t("SECURED_CARD_TITLE")}
                    </span>

                    <p className="hidden md:block
                    font-hanken-grotesk font-medium text-[18px]/[28px] tracking-[0em]
                    text-[#FEFAEE] text-left max-w-[48ch]">
                        {t("SECURED_CARD_TEXT")}
                    </p>

                    <button
                        onClick={showSecuredCreditPopover}
                        className="
          mt-4 md:mt-12 inline-flex items-center justify-center
          border-[2.5px] border-[#FEFAEE] font-bold text-[18px]/[46.09px]
          px-7 py-3 text-white bg-transparent
          transition-colors duration-200 ease-out 
        h-[55px] rounded-[88.64px]
          w-full max-w-[320px] h-[55px]
          self-center
          md:w-[165px] md:self-end
        "
                    >
                        {t("LEARN_MORE")}
                    </button>
                </div>

            </div>
        </DynamicCard>


    );
};

export default SecuredCreditCardPromotion;
